export default __webpack_public_path__ + "static/media/product-code.cb6d6c58.png";